import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Hidden } from '@mui/material';
import { MoreVert, ViewList, Menu } from '@mui/icons-material';
import { IconButton } from '@totalsoft/rocket-ui';
import { reduce } from 'ramda';
import menuConfig from 'constants/menuConfig';
import { emptyArray } from 'utils/constants';
import { useHeader } from 'providers/AreasProvider';
import { AppBar, Toolbar, MinimizeSidebar, StyledTitle, StyledMobileTitle, HeaderResponsive } from './HeaderStyle';
import HeaderLinks from './HeaderLinks';
import { useTitle } from 'hooks/useTitle';
import { useOidcUser } from '@axa-fr/react-oidc';
import { getOidcConfigName } from 'utils/functions';

const flatten = (arr, value) => arr.concat(value).concat(value.children ? flattenConfig(value.children) : emptyArray);
const flattenConfig = config => reduce(flatten, emptyArray, config);

function Header({ drawerMinimized, handleDrawerMinimizeToggle, handleDrawerOpenToggle }) {
  const { t } = useTranslation();
  const location = useLocation();
  const [header] = useHeader();
  const { oidcUser } = useOidcUser(getOidcConfigName());

  const makeBrand = pathname => {
    var name;
    flattenConfig(menuConfig).map(menu => {
      if (menu.path === pathname) {
        name = menu.name;
      }
      return null;
    });
    if (pathname === '/my-profile') {
      name = 'User';
    }

    return name || '';
  };

  const getPageTitle = () => {
    return pathName && t('NavBar.' + pathName);
  };

  const pathName = makeBrand(location.pathname);

  useTitle(getPageTitle());

  return (
    oidcUser && (
      <AppBar position='sticky'>
        <Toolbar>
          <Hidden mdDown>
            <MinimizeSidebar>
              {drawerMinimized ? (
                <IconButton onClick={handleDrawerMinimizeToggle} color='primary' variant='text' size='medium'>
                  <MoreVert fontSize='small' />
                </IconButton>
              ) : (
                <IconButton onClick={handleDrawerMinimizeToggle} color='primary' variant='text' size='medium'>
                  <ViewList fontSize='small' />
                </IconButton>
              )}
            </MinimizeSidebar>
            {header || <StyledTitle variant='subtitle1'>{pathName && t('NavBar.' + pathName)}</StyledTitle>}
          </Hidden>
          <Hidden mdUp>{header || <StyledMobileTitle variant='subtitle1'>{pathName && t('NavBar.' + pathName)}</StyledMobileTitle>}</Hidden>

          <HeaderLinks />

          <Hidden mdUp>
            <HeaderResponsive>
              <IconButton color='primary' variant='text' size='medium' aria-label='open drawer' onClick={handleDrawerOpenToggle}>
                <Menu fontSize='small' />
              </IconButton>
            </HeaderResponsive>
          </Hidden>
        </Toolbar>
      </AppBar>
    )
  );
}

Header.propTypes = {
  drawerMinimized: PropTypes.bool.isRequired,
  handleDrawerMinimizeToggle: PropTypes.func,
  handleDrawerOpenToggle: PropTypes.func
};

export default Header;
